import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../components/Grid'
import StripePageTitle from '../components/StripePageTitle'
import StripeTabs from '../components/StripeTabs'
import StripeKPIs from '../components/StripeKPIs'
import StripeActiveFilters from '../components/StripeActiveFilters'
import UbliqueContainer from '../components/Container'
import { noop } from 'lodash'

import './index.scss'

const PageOutputKpisTabs = ({
  title,
  className,
  stripeKpis,
  stripeTabs,
  stripeModal,
  stripeActiveFilters,
  configMenu,
  stripeKpisTitle,
  stripeKpisComponent,
  onTabChange = noop
}) => {
  return (
    <UbliqueContainer stripeModal={stripeModal}>
      <Grid className={cn('ublique-page-kpis-tabs', className)}>
        {title && <StripePageTitle text={title} configMenu={configMenu} />}
        {stripeActiveFilters && (
          <StripeActiveFilters filterProps={stripeActiveFilters} />
        )}
        {stripeKpis && (
          <StripeKPIs
            kpis={stripeKpis}
            stripeKpisTitle={stripeKpisTitle}
            stripeKpisComponent={stripeKpisComponent}
          />
        )}
        {stripeTabs && (
          <StripeTabs tabs={stripeTabs} onTabChange={onTabChange} />
        )}
      </Grid>
    </UbliqueContainer>
  )
}

PageOutputKpisTabs.propTypes = {
  // da sistemare con Yup
  title: PropTypes.string,
  className: PropTypes.string,
  stripeTabs: PropTypes.array.isRequired,
  stripeModal: PropTypes.object,
  stripeActiveFilters: PropTypes.object,
  configMenu: PropTypes.object
}

export default PageOutputKpisTabs
